import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
	Typography,
	Button,
	Paper,
	Grid,
	TextField,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListItemSecondaryAction,
	IconButton,
	Tooltip,
	Divider
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import { NavLink } from "react-router-dom";

import InfoTooltip from "../general/InfoTooltip";
import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";

import SaveIcon from "@material-ui/icons/Save";
import GetAppIcon from "@material-ui/icons/GetApp";
import SettingsInputCompositeIcon from "@material-ui/icons/SettingsInputComposite";
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteIcon from '@material-ui/icons/Delete';

import { DropzoneArea } from "material-ui-dropzone";


const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto"
	},
	actionButtons: theme.actionButtons,
	settingsGroup: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	dropzone: {
		padding: 20,
		height: 200,
		minHeight: 200,
		fontFamily: "Roboto, 'Segoe UI', 'Helvetica Neue', Arial",
		fontSize: 13,
		textTransform: "uppercase",
		letterSpacing: 1,
		"& p": {
			fontSize: 13,
		},
	},
}));

export default function NotificationSettings(props) {
	const theme = useTheme();
	const classes = useStyles();
	const [notification, setNotification] = useState("");
	const [notificationEnabled, setNotificationEnabled] = useState(false);

	const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);

	useEffect(() => {
		getNotification();
	}, []);


	const getNotification = () => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/string/notification`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then(({ data }) => {
				setNotification(data.value);
				setNotificationEnabled(data.value !== "");
			})
			.catch((err) => {
				if (err.response && err.response.data && err.response.data.message)
					pageContext.setErrorMessage(err.response.data.message);
				else
					pageContext.setErrorMessage("Die Einstellung konnte nicht geladen werden!");
			});
	}


	const saveNotification = (value = null) => {
		const newNotification = value !== null ? value : notification;
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/notification`,
			data: {
				value: newNotification
			},
			method: 'put',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				pageContext.setInfoMessage("Einstellung wurde gespeichert");
			})
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Einstellung konnte nicht gespeichert werden!");
			});
	}


	return (
		<div className={classes.root}>
			<div className={classes.actionButtons}>

			</div>
			<Typography variant="h2">Benachrichtigungen</Typography>
			<Typography>Du kannst hier eine Nachricht schreiben, die allen Benutzern nach dem Login direkt auf der Startseite angezeigt wird.</Typography>
			<br />

			<Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item>
						<Typography>Benachrichtigung aktivieren?</Typography>
					</Grid>
					<Grid item>
						<Button
							variant={notificationEnabled ? "contained" : "outlined"}
							size="small"
							onClick={() => {
								setNotificationEnabled(true);
							}}>
							Ja
						</Button>
					</Grid>
					<Grid item>
						<Button
							variant={notificationEnabled ? "outlined" : "contained"}
							size="small"
							onClick={() => {
								setNotificationEnabled(false);
								setNotification("");
								saveNotification("");
							}}>
							Nein
						</Button>
					</Grid>
					{notificationEnabled &&
						<Grid item xs={12}>
							<TextField
								fullWidth
								multiline
								type="text"
								variant="outlined"
								name="notification"
								value={notification ? notification : ""}
								// error={error !== null}
								// helperText={error}
								label="Benachrichtigung"
								onChange={(e) => {
									setNotification(e.target.value);
								}}
								onBlur={() => {

								}}
							/>
							<br /><br />
							<Button
								variant="contained"
								color="primary"
								size="small"
								onClick={() => {
									saveNotification();
								}}
								startIcon={<SaveIcon />}
							>
								speichern
							</Button>
						</Grid>
					}
				</Grid>
			</Paper>
		</div>
	);
}
